import { DateTime } from 'luxon';
import { computed } from 'vue';
import { extractFileNameFromFile } from '@/utils/extract-file-name';
import { useCreateWorkshopAppointmentDocument } from '@/queries/use-workshop-appointment-documents';
import { uploadService } from '@/api/upload.service';
import type { WorkshopAppointmentDocumentType } from '@carvia/ros-client-types';

export const useUploadAndCreateWorkshopAppointmentDocument = () => {
  const { mutateAsync: createWorkshopAppointmentDocument, isPending: isCreatingDocument } =
    useCreateWorkshopAppointmentDocument();

  const isUploadingDocument = computed(() => false);
  const isPending = computed(() => isCreatingDocument.value || isUploadingDocument.value);

  const uploadAndCreateWorkshopAppointmentDocument = async (
    workshopAppointmentId: string,
    file: File,
    type: WorkshopAppointmentDocumentType,
    documentName: string,
    comment?: string,
  ) => {
    const { suffix, fileName } = extractFileNameFromFile(file);
    const timestamp = DateTime.now().toISO()?.replace(/:/g, '-') ?? Date.now().toString();
    const finalFileName = `${fileName}-${timestamp}.${suffix}`;
    const { fileKey } = await uploadService.uploadWorkshopAppointmentDocument(
      { workshopAppointmentId, fileName: finalFileName },
      file,
    );
    await createWorkshopAppointmentDocument({
      workshopAppointmentId,
      document: {
        name: documentName,
        type,
        documentFileKey: fileKey,
        comment,
      },
    });
  };

  return { uploadAndCreateWorkshopAppointmentDocument, isPending };
};
